var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 135,
    viewBox: "0 0 168 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.331 48.6437V135H153.078V48.6437C153.078 29.2619 139.625 14.2105 121.883 14.2105C104.14 14.2105 90.939 29.2619 90.939 48.6437V135H76.3921V48.6437C76.3921 29.2619 62.9384 14.2105 45.4485 14.2105C27.9586 14.2105 14.2526 29.2619 14.2526 48.6437V135H0V48.6437C0 45.953 0.25228 43.8088 0.25228 44.6076L0 0.756775L14.2526 0.504515L14.5048 12.3606C17.7422 7.52569 30.9016 0 45.4485 0C62.9384 0 78.8306 11.3096 83.6655 22.0726C88.5005 11.3096 104.393 0 121.883 0C146.646 0 167.331 22.0726 167.331 48.6858V48.6437Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerM);
export default __webpack_public_path__ + "static/media/LOWER_M.d6fc32a82fa119568cd093cbaf5b0f41.svg";
export { ForwardRef as ReactComponent };